// extracted by mini-css-extract-plugin
export default {"profileIcon":"NavigationBar_profileIcon__dsLrf"};